var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { PublicKey, SystemProgram, TransactionMessage, VersionedTransaction, } from '@solana/web3.js';
import bs58 from 'bs58';
export var JITO_FEE = 1700000;
var jitoTipAccounts = [
    'Cw8CFyM9FkoMi7K7Crf6HNQqf4uEMzpKw6QNghXLvLkY',
    'DttWaMuVvTiduZRnguLF7jNxTgiMBZ1hyAumKUiL2KRL',
    '96gYZGLnJYVFmbjzopPSU6QiEV5fGqZNyN9nmNhvrZU5',
    '3AVi9Tg9Uo68tJfuvoKvqKNWKkC5wPdSSdeBnizKZ6jT',
    'HFqU5x63VTqvQss8hp11i4wVV8bD44PvwucfZ2bU7gRe',
    'ADaUMid9yfUytqMBgopwjb2DTLSokTSzL1zt6iGPaS49',
    'ADuUkR4vqLUMWXxW9gh6D6L8pMSawimctcNZ5pGwDcEt',
    'DfXygSm4jCyNCybVYYK6DwvWqjKee8pbDmJGcLWNDXjh',
];
var getRandomValidatorKey = function () {
    var randomValidator = jitoTipAccounts[Math.floor(Math.random() * jitoTipAccounts.length)];
    return new PublicKey(randomValidator);
};
export var bundle = function (txs, keypair, connection, priorityFee) { return __awaiter(void 0, void 0, Promise, function () {
    var abortController, txNum, successNum, results_1, i, upperIndex, downIndex, newTxs, j, tip, success, successValue, error, signatures, links, successResults, error_1;
    var _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                abortController = new AbortController();
                _c.label = 1;
            case 1:
                _c.trys.push([1, 6, 7, 8]);
                txNum = Math.ceil(txs.length / 3);
                successNum = 0;
                results_1 = [];
                i = 0;
                _c.label = 2;
            case 2:
                if (!(i < txNum)) return [3 /*break*/, 5];
                upperIndex = (i + 1) * 3;
                downIndex = i * 3;
                newTxs = [];
                for (j = downIndex; j < upperIndex; j++) {
                    if (txs[j])
                        newTxs.push(txs[j]);
                }
                tip = priorityFee ? priorityFee : JITO_FEE;
                return [4 /*yield*/, bull_dozer(newTxs, keypair, connection, abortController.signal, tip)];
            case 3:
                success = _c.sent();
                successValue = success.success, error = success.error, signatures = success.signatures, links = success.links;
                console.log('successfully finished bulldozer', success);
                if (success && successValue > 0)
                    successNum += 1;
                results_1.push(success);
                _c.label = 4;
            case 4:
                i++;
                return [3 /*break*/, 2];
            case 5:
                if (successNum == 0) {
                    return [2 /*return*/, {
                            error: 'No successful responses received from Jito',
                            note: 'jito bundle error',
                            network: 1399811149,
                            status: 'error',
                            errorTags: 'LIT, RUN_ONCE, JITO_BUNDLE - signAndSendSolanaJito',
                        }];
                }
                successResults = (_b = (_a = results_1 === null || results_1 === void 0 ? void 0 : results_1[0]) === null || _a === void 0 ? void 0 : _a.signatures) === null || _b === void 0 ? void 0 : _b.map(function (signature) {
                    var _a;
                    return {
                        status: 'success',
                        hash: signature,
                        network: 1399811149,
                        explorerUrl: "https://solscan.io/tx/".concat(signature),
                        bundleId: (_a = results_1 === null || results_1 === void 0 ? void 0 : results_1[0]) === null || _a === void 0 ? void 0 : _a.bundleId,
                    };
                });
                if (!successResults || successResults.length == 0) {
                    return [2 /*return*/, {
                            error: 'Executing Order SOLANA No successful responses received from Jito - transactions failed',
                            note: 'jito bundle error',
                            network: 1399811149,
                            status: 'error',
                        }];
                }
                return [2 /*return*/, successResults];
            case 6:
                error_1 = _c.sent();
                console.log('Executing Order SOLANA jito bundle error', error_1.message);
                return [2 /*return*/, {
                        error: error_1.message.slice(0, 400),
                        note: 'jito bundle error',
                        network: 1399811149,
                    }];
            case 7:
                abortController.abort();
                return [7 /*endfinally*/];
            case 8: return [2 /*return*/];
        }
    });
}); };
export var bull_dozer = function (txs, payer, connection, abortSignal, priorityFee) { return __awaiter(void 0, void 0, void 0, function () {
    var jitoFeeWallet, latestBlockhash, jitTipTxFeeMessage, jitoFeeTx, jitoTxsignature, serializedJitoFeeTx, serializedTransactions_1, sigrequired, endpoints, requests, results, bundleId, successfulResults, error_2;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 3, , 4]);
                jitoFeeWallet = getRandomValidatorKey();
                return [4 /*yield*/, connection.getLatestBlockhash('confirmed')];
            case 1:
                latestBlockhash = _b.sent();
                jitTipTxFeeMessage = new TransactionMessage({
                    payerKey: payer.publicKey,
                    recentBlockhash: latestBlockhash.blockhash,
                    instructions: [
                        SystemProgram.transfer({
                            fromPubkey: payer.publicKey,
                            toPubkey: jitoFeeWallet,
                            lamports: priorityFee,
                        }),
                    ],
                }).compileToV0Message();
                jitoFeeTx = new VersionedTransaction(jitTipTxFeeMessage);
                jitoFeeTx.sign([payer]);
                jitoTxsignature = bs58.encode(jitoFeeTx.signatures[0]);
                serializedJitoFeeTx = bs58.encode(jitoFeeTx.serialize());
                serializedTransactions_1 = __spreadArray([
                    serializedJitoFeeTx
                ], txs.map(function (tx) { return bs58.encode(tx.serialize()); }), true);
                sigrequired = __spreadArray([jitoFeeTx], txs, true).map(function (tx) {
                    var requiredSigners = tx.message.staticAccountKeys
                        .filter(function (_, index) { return tx.message.isAccountSigner(index); })
                        .map(function (pubkey) { return pubkey.toBase58(); });
                    var providedSignatures = tx.message.staticAccountKeys
                        .filter(function (_, index) { return tx.message.isAccountSigner(index); })
                        .map(function (pubkey, index) { return ({
                        pubkey: pubkey.toBase58(),
                        signature: tx.signatures[index] ? bs58.encode(tx.signatures[index]) : null,
                    }); });
                    // Find missing signatures
                    var missingSignatures = requiredSigners.filter(function (required, index) { var _a; return tx.signatures[index] === null || ((_a = tx.signatures[index]) === null || _a === void 0 ? void 0 : _a.every(function (byte) { return byte === 0; })); });
                    return {
                        requiredSigners: requiredSigners,
                        providedSignatures: providedSignatures,
                        missingSignatures: missingSignatures,
                    };
                });
                console.log('siggssss', JSON.stringify(sigrequired, null, 2));
                endpoints = [
                    'https://mainnet.block-engine.jito.wtf/api/v1/bundles',
                    'https://amsterdam.mainnet.block-engine.jito.wtf/api/v1/bundles',
                    'https://frankfurt.mainnet.block-engine.jito.wtf/api/v1/bundles',
                    'https://ny.mainnet.block-engine.jito.wtf/api/v1/bundles',
                    'https://tokyo.mainnet.block-engine.jito.wtf/api/v1/bundles',
                ];
                requests = endpoints.map(function (url) { return __awaiter(void 0, void 0, void 0, function () {
                    var response, json;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, fetch(url, {
                                    method: 'POST',
                                    headers: {
                                        'Content-Type': 'application/json',
                                    },
                                    body: JSON.stringify({
                                        jsonrpc: '2.0',
                                        id: 1,
                                        method: 'sendBundle',
                                        params: [serializedTransactions_1],
                                    }),
                                    signal: abortSignal,
                                })];
                            case 1:
                                response = _a.sent();
                                if (!!response.ok) return [3 /*break*/, 3];
                                return [4 /*yield*/, response.json()];
                            case 2:
                                json = _a.sent();
                                console.log('executing order not okay response for url', url, json);
                                throw new Error("HTTP error! status: ".concat(response.status));
                            case 3: return [2 /*return*/, response.json()];
                        }
                    });
                }); });
                console.log('Executing Order SOLANA sending jito bundle');
                return [4 /*yield*/, Promise.all(requests.map(function (p) { return p.catch(function (e) { return e; }); }))];
            case 2:
                results = _b.sent();
                console.log('Executing Order SOLANA jitoresults', { results: results });
                bundleId = (_a = results === null || results === void 0 ? void 0 : results.find(function (result) { return result === null || result === void 0 ? void 0 : result.result; })) === null || _a === void 0 ? void 0 : _a.result;
                successfulResults = results
                    .filter(function (result) { return result !== null; })
                    .filter(function (result) { return !(result instanceof Error); });
                if (successfulResults.length > 0) {
                    // const confirmation = await connection.confirmTransaction(
                    //   {
                    //     signature: jitoTxsignature,
                    //     blockhash: latestBlockhash.blockhash,
                    //     lastValidBlockHeight: latestBlockhash.lastValidBlockHeight,
                    //   },
                    //   'confirmed'
                    // );
                    // if (confirmation.value.err)
                    //   return {
                    //     success: 0,
                    //     error: confirmation?.value?.err,
                    //   };
                    txs.map(function (tx) {
                        return console.log("TX Confirmed: https://solscan.io/tx/".concat(bs58.encode(tx.signatures[0])));
                    });
                    return [2 /*return*/, {
                            success: 1,
                            bundleId: bundleId,
                            signatures: txs.map(function (tx) { return bs58.encode(tx.signatures[0]); }),
                            links: txs.map(function (tx) { return "https://solscan.io/tx/".concat(bs58.encode(tx.signatures[0])); }),
                        }];
                }
                else {
                    console.log("No successful responses received for jito");
                }
                return [2 /*return*/, {
                        success: 0,
                        error: 'No successful responses received for jito',
                    }];
            case 3:
                error_2 = _b.sent();
                console.log('Executing Order SOLANA  JITO Error during transaction execution', error_2);
                return [2 /*return*/, {
                        success: 0,
                        error: error_2,
                    }];
            case 4: return [2 /*return*/];
        }
    });
}); };
export function checkJitoBundleStatus(bundleId) {
    return __awaiter(this, void 0, Promise, function () {
        var maxTime, startTime, elapsedTime, body, resp, data, bundleStatus, error_3;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    maxTime = 60 * 1000;
                    startTime = Date.now();
                    elapsedTime = 0;
                    _c.label = 1;
                case 1:
                    if (!(elapsedTime < maxTime)) return [3 /*break*/, 11];
                    _c.label = 2;
                case 2:
                    _c.trys.push([2, 8, , 10]);
                    body = {
                        jsonrpc: '2.0',
                        id: 1,
                        method: 'getInflightBundleStatuses',
                        params: [[bundleId]],
                    };
                    return [4 /*yield*/, fetch('https://mainnet.block-engine.jito.wtf/api/v1/bundles', {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json',
                            },
                            body: JSON.stringify(body),
                        })];
                case 3:
                    resp = _c.sent();
                    if (!resp.ok) {
                        throw new Error("HTTP error! status: ".concat(resp.status));
                    }
                    return [4 /*yield*/, resp.json()];
                case 4:
                    data = _c.sent();
                    console.log('Executing order Jito bundle status:', data);
                    if (data.error) {
                        throw new Error("API error: ".concat(data.error.message));
                    }
                    bundleStatus = (_b = (_a = data.result) === null || _a === void 0 ? void 0 : _a.value) === null || _b === void 0 ? void 0 : _b[0];
                    if (!!bundleStatus) return [3 /*break*/, 6];
                    console.log('Bundle not found or invalid response');
                    return [4 /*yield*/, new Promise(function (resolve) { return setTimeout(resolve, 500); })];
                case 5:
                    _c.sent();
                    elapsedTime = Date.now() - startTime;
                    return [3 /*break*/, 1];
                case 6:
                    if (bundleStatus.status === 'Failed' || bundleStatus.status === 'Landed') {
                        return [2 /*return*/, bundleStatus.status];
                    }
                    return [4 /*yield*/, new Promise(function (resolve) { return setTimeout(resolve, 500); })];
                case 7:
                    _c.sent();
                    elapsedTime = Date.now() - startTime;
                    return [3 /*break*/, 10];
                case 8:
                    error_3 = _c.sent();
                    console.error('Error checking bundle status:', error_3);
                    return [4 /*yield*/, new Promise(function (resolve) { return setTimeout(resolve, 500); })];
                case 9:
                    _c.sent();
                    elapsedTime = Date.now() - startTime;
                    return [3 /*break*/, 10];
                case 10: return [3 /*break*/, 1];
                case 11: throw new Error("Timeout: Bundle ".concat(bundleId, " status not resolved after ").concat(maxTime, "ms"));
            }
        });
    });
}
